import { render, staticRenderFns } from "./AboutStore.vue?vue&type=template&id=1611cb5c"
import script from "./AboutStore.vue?vue&type=script&lang=js"
export * from "./AboutStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports